export {default as FaqListView}from './faq-list-view';
export {default as FaqCreateView}from './faq-create-view';
export {default as FaqEditView}from './faq-edit-view';